import React, { useEffect } from "react";
import { gsap } from "helpers/gsap";
import { Wrapper, Title, Description, Subtitle } from "./index.styled";

const Copy = ({ data, slider, children }) => {
  const {
    color,
    mobileColor,
    size,
    align,
    title,
    description,
    subtitle,
    width,
    titleMobileMargin,
    lineHeight,
    mobileDescriptionPadding,
  } = data;

  const refCopy = React.useRef(null);
  const refCopyTitle = React.useRef(null);
  const refCopyDescription = React.useRef(null);
  const refCopysubtitle = React.useRef(null);

  useEffect(() => {
    let gsapContext = gsap.context(() => {
      const mediaQueryAnimation = gsap.matchMedia();
      // mediaQueryAnimation.add("(min-width: 1025px)", () => {
      if (slider !== true) {
        const copyAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: refCopy?.current,
            start: "top 65%",
            toggleActions: "play none none reverse",
          },
        });

        data?.subtitle &&
          copyAnimation.from(
            refCopysubtitle?.current,
            {
              duration: 0.55,
              opacity: 0,
              y: 20,
            },
            0
          );
        data?.title &&
          copyAnimation.from(
            refCopyTitle?.current,
            {
              duration: 0.75,
              opacity: 0,
              y: 20,
            },
            0
          );

        data?.description &&
          copyAnimation.from(
            refCopyDescription?.current,
            {
              duration: 1,
              opacity: 0,
              y: 20,
            },
            0
          );
      }
      // });
    }, refCopy);

    return () => gsapContext.revert();
  }, []);

  return (
    <Wrapper ref={refCopy}>
      {subtitle && (
        <Subtitle
          ref={refCopysubtitle}
          $mobileColor={mobileColor}
          $color={color}
        >
          {subtitle}
        </Subtitle>
      )}
      {data?.title && (
        <Title
          ref={refCopyTitle}
          $mobileMargin={titleMobileMargin}
          $color={color}
          $mobileColor={mobileColor}
          $size={size}
          $align={align}
        >
          {title}
        </Title>
      )}
      {children && children}
      {description && (
        <Description
          ref={refCopyDescription}
          $mobileDescriptionPadding={mobileDescriptionPadding}
          $color={color}
          $mobileColor={mobileColor}
          $align={align}
          $width={width}
          $lineHeight={lineHeight}
        >
          {description}
        </Description>
      )}
    </Wrapper>
  );
};

export default Copy;
